import { makeAutoObservable } from 'mobx';

class ThemeStore {
  theme = localStorage.getItem('trocyo-theme') || 'light';

  constructor() {
    makeAutoObservable(this);
    this.applyTheme(this.theme);
  }

  toggleTheme() {
    this.theme = this.theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('trocyo-theme', this.theme);
    this.applyTheme(this.theme);
  }

  applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }

  get isDark() {
    return this.theme === 'dark';
  }
}

const themeStore = new ThemeStore();
export default themeStore;
